import React, { useRef, useState } from 'react';
import { Link } from 'gatsby';

import CategoryFilterSidebar from './category-filter';
import LongText from '../../common/long-text';
import PrintSortingOptions from './print-sorting-options';
import ShopSearchDrawer from '../../search/shop-search-drawer';
import ThemedPrintSets from './themed-print-sets';

import { SearchSvg } from '../../common/svg';

import '../../../styles/shop/category-filter-drawer.scss';

const CategoryFilterDrawer = (props) => {
  const [themedSetsOpen, setThemedSetsOpen] = useState(props.defaultThemedSetsOpen);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);

  const toggleFilterDrawers = (drawer) => {
    setThemedSetsOpen(false);
    setFiltersOpen(false);
    setSearchOpen(false);
    setAboutOpen(false);
    setSortOpen(false);

    if (drawer === 'themed-sets' && !themedSetsOpen) {
      setThemedSetsOpen(true);
    }

    if (drawer === 'filters' && !filtersOpen) {
      setFiltersOpen(true);
    }

    if (drawer === 'search' && !searchOpen) {
      setSearchOpen(true);

      setTimeout(() => searchFieldRef.current.focus(), 100);
    }

    if (drawer === 'about' && !aboutOpen) {
      setAboutOpen(true);
    }

    if (drawer === 'sort' && !sortOpen) {
      setSortOpen(true);
    }
  }

  const searchFieldRef = useRef();

  let containerClasses = 'category-filter-drawer';
  containerClasses += (props.pagePosition === 'top') ? ' top-filter' : ' bottom-filter';
  containerClasses += props.addTopMargin ? ' with-top-margin' : '';

  return (
    <div className={ containerClasses }>
      <div
        className="product-category__expand-filters"
      >
        <button
          className={ `product-category__expand-filters__tab ${searchOpen ? 'expanded' : ''}` }
          onClick={() => toggleFilterDrawers('search') }
        >
          <span className="hide-on-mobile">
            { SearchSvg }{' '}
          </span>
          Search<span className="hide-on-small-viewports"> the Shop</span>
        </button>
        <button
          className={ `product-category__expand-filters__tab ${themedSetsOpen ? 'expanded' : ''}` }
          onClick={() => toggleFilterDrawers('themed-sets') }
        >
          <span className="hide-on-mobile">
            {themedSetsOpen ? '-' : '+' }{' '}
          </span>
          <span className="hide-on-small-viewports">Explore </span><span className="hide-on-mobile">Themed </span>Sets
        </button>
        <button
          className={ `product-category__expand-filters__tab ${filtersOpen ? 'expanded' : ''}` }
          onClick={() => toggleFilterDrawers('filters') }
        >
          <span className="hide-on-mobile">
            {filtersOpen ? '-' : '+' }{' '}
          </span>
          Filter
        </button>
        <button
          className="product-category__expand-filters__tab view-all-tab"
          onClick={() => window.location.href = '/shop/fine-art-prints/all'}
        >
          <span className="hide-on-mobile">View</span> All
        </button>
        <button
          className={ `product-category__expand-filters__tab ${aboutOpen ? 'expanded' : ''}` }
          onClick={() => toggleFilterDrawers('about') }
        >
          <span className="hide-on-mobile">
            {aboutOpen ? '-' : '+' }{' '}
          </span>
          About<span className="hide-on-small-viewports"> Our Prints</span>
        </button>
        <span className="product-category__expand-filters__tab product-category__expand-filters__empty-tab" />
        {props.suppressSortTab ? null : (
          <button
            className={ `product-category__expand-filters__tab product-category__expand-filters__sort-tab ${sortOpen ? 'expanded' : ''}` }
            onClick={() => toggleFilterDrawers('sort') }
          >
            <span className="hide-on-mobile">
              {sortOpen ? '-' : '+' }{' '}
            </span>
            Sort
          </button>
        )}
      </div>
      {searchOpen && (
        <ShopSearchDrawer
          expanded={ true }
          searchFieldRef={ searchFieldRef }
        />
      )}
      {filtersOpen && (
        <div className="product-category__filter-groups">
          <CategoryFilterSidebar
            categorySlug={props.categorySlug}
            sortSlug={props.sortSlug}
          />
        </div>
      )}
      {themedSetsOpen && (
        <ThemedPrintSets
          themedSets={ props.themedSets }
          sortSlug={ props.sortSlug }
        />
      )}
      {aboutOpen && (
        <div style={ { marginTop: '2rem', marginBottom: '2rem' } }>
          <LongText>
            <p>
              Through our prints shop we offer custom-made prints of exceptional quality — available
              unframed or framed and delivered to your door. Printed by the Giclée process
              and utilising premium archival materials, our prints are made to last generations.
              All proceeds from sales go back into <i>The Public Domain Review</i> (a not-for-profit
              project) and make up roughly 25% of our funding. Learn more about the prints and shipping
              process <Link to="/shop/about-our-prints">here</Link>.
            </p>
          </LongText>
        </div>
      )}
      {sortOpen && (
        <PrintSortingOptions
          filterAttribute={ props.filterAttribute }
          filterValue={ props.filterValue }
        />
      )}
    </div>
  );
};

export default CategoryFilterDrawer;
